import { createStyles } from '@mantine/core';

export const useStyles = createStyles((theme) => ({
  measuresWrapper: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    gap: '24px',
  },
  measuresContainer: {
    width: '100%',
    display: 'flex',
    gap: '10px',
    alignItems: "start",
  },
  contentContainer: {
    padding: '20px',
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
    paddingTop: '0',

  },
  button: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    padding: '8px',
    paddingLeft: '24px',
    width: 'auto',
    background: '#EB2F96',
    borderRadius: '5px',
    border: 'none',
    color: '#ffffff',
    ':hover': {
      cursor: 'pointer',
    },
  },
  aadharImgWrapper: {
    maxHeight: 220,
  },
  aadharIcons: {
    padding: "1.5rem",
    border: `1px solid ${theme.other.colors.disabled.muted}`,
    borderRadius: "100%",
    background: theme.other.colors.base.white,
  },
  zIndexOne: {
    zIndex: 1,
  },
  zIndexTwo: {
    zIndex: 2,
  },
}));

export default useStyles;
